import React from "react";
import { useIonToast } from "@ionic/react";

const Ctx = React.createContext();
export function ToastProvider({ children }) {
  const [toast] = useIonToast();

  const addToast = (content) => {
    toast({
      message: typeof content === "string" ? content : content.message,
      duration: content.duration?.typeof === "number" ? content.duration : 1500,
      position: "bottom",
      color: content.color?.typeof === "string" ? "" : content.color,
    });
  };

  return <Ctx.Provider value={{ addToast }}>{children}</Ctx.Provider>;
}

export const useToasts = () => React.useContext(Ctx);
